import React from 'react';

const SvgAlertWarning = props => (
  <svg
    data-name="ic_warning"
    width={props.size || 80.197}
    height={props.size || 80.197}
    viewBox="0 0 80.197 80.197"
    fill="#fcc52c"
    {...props}
  >
    <g data-name="002-alert">
      <path
        d="M40.1 0a40.1 40.1 0 1040.1 40.1A40.144 40.144 0 0040.1 0zm0 77.112A37.014 37.014 0 1177.112 40.1 37.057 37.057 0 0140.1 77.112z"
        className="alert_warning_svg__cls-1"
        data-name="Path 207"
      />
      <path
        d="M40.098 15.422a1.542 1.542 0 00-1.542 1.542v33.93a1.542 1.542 0 003.084 0v-33.93a1.542 1.542 0 00-1.542-1.542z"
        className="alert_warning_svg__cls-1"
        data-name="Path 208"
      />
      <path
        d="M40.098 57.063a1.542 1.542 0 00-1.542 1.542v3.084a1.542 1.542 0 103.084 0v-3.084a1.542 1.542 0 00-1.542-1.542z"
        className="alert_warning_svg__cls-1"
        data-name="Path 209"
      />
    </g>
  </svg>
);

export default SvgAlertWarning;
